import { render, staticRenderFns } from "./LecturarPlanillas.vue?vue&type=template&id=4a2bfa3f&"
import script from "@/Servicios/LecturarPlanillas.js?vue&type=script&lang=js&"
export * from "@/Servicios/LecturarPlanillas.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports